<template>
    <div id="cb4x-content">
        <h4>{{ headerBlock.title }}</h4>
        <p>
            <ob1-capsule
                :is-information="true"
                :label="headerBlock.feesLabel"
            />
            <strong>{{ headerBlock.subTitle }}</strong>
        </p>
        <div class="row-flex">
            <p v-if="paymentExampleBlock" class="lead mb-0">
                <strong>{{ paymentExampleBlock.title }}</strong>
            </p>
            <p v-else class="lead mb-0">
                <strong>{{ paymentBlock.title }}</strong>
            </p>
            <div v-if="paymentExampleBlock" class="lead" v-html="paymentExampleBlock.subTitle" />
            <div class="row justify-content-between">
                <div class="col-3 col-md-2">
                    <p class="mb-0">
                        {{ paymentSimulationBlock.text2 }}
                    </p>
                </div>
                <div class="col-9 col-md-10">
                    <p class="mb-0">
                        <strong>{{ formatNumberToString(oneShotPrice) }} €</strong>
                        <br>
                        {{ paymentSimulationBlock.text3 }}
                    </p>
                </div>
            </div>
            <ob1-separateur color="gray1" class="my-1" />
            <div class="row justify-content-between">
                <div class="col-3 col-md-2">
                    <p v-html="paymentSimulationBlock.text5" />
                </div>
                <div class="d-flex col-9 col-md-10 justify-content-between">
                    <div class="row w-100">
                        <div class="col-10 col-md-5">
                            <p class="mb-0">
                                <strong>{{ formatNumberToString(firstMonthlyPrice) }} €</strong>
                                <br>
                                {{ paymentSimulationBlock.text4 }}
                            </p>
                        </div>
                        <div class="col-2">
                            <p class="mb-0">
                                <strong>+</strong>
                            </p>
                        </div>
                        <div class="col col-md-5">
                            <div>
                                <p class="mb-0">
                                    <strong>{{ formatNumberToString(monthlyPrice) }} €/mois</strong>
                                    <br>
                                    {{ paymentSimulationBlock.text9 }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="justify-content-between d-flex w-100">
                    <div class="col-3 col-md-2">
                        <p />
                    </div>
                    <div class="col-9 col-md-10">
                        <p class="mb-0">
                            {{ paymentSimulationBlock.text6 }}
                            <strong>{{ formatNumberToString(oneShotPrice) }} €</strong>
                            <br>
                            {{ paymentSimulationBlock.text7 }}
                            <br>
                            {{ paymentSimulationBlock.text8 }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="illustration" class="row pt-2 pb-1">
            <ob1-picture :visual="illustration" class="illustration" css-classes="d-block mx-auto" />
        </div>
        <!--Bloc comment profiter-->
        <div v-if="howToBenefit" class="bg-gray2 px-2 pb-1 mb-1 mb-md-2">
            <p class="mb-0">
                <span class="lead">
                    <strong>{{ howToBenefit.title }}</strong>
                </span>
                <br>
                <strong>{{ howToBenefit.subTitle }}</strong>
            </p>
            <p
                v-for="(howToBenefitText, index) in howToBenefit.texts"
                :key="'how-to-'+index"
                class="d-flex align-items-center mb-0"
            >
                <span class="font-size-24" :class="'icon-number-' + getIndex(index) +'-wired'" aria-hidden="true" />
                <span class="ms-1" v-html="howToBenefitText" />
            </p>
        </div>

        <!--Bloc Faq-->
        <section v-if="faq">
            <h4 class="my-2" v-html="faq.title" />
            <div id="cb4x-content-faq" class="accordion mb-1">
                <div
                    v-for="(textBlock, index) in faq.textsBlock"
                    :key="'cb4x-content-faq-'+index"
                >
                    <ob1-expanding-accordion-card
                        :ref="'cb4x-content-faq-link' + index"
                        :collapsed-block-id="'cb4x-content-faq' + index"
                        :link-id="'cb4x-content-faq-link' + index"
                        :link-title="textBlock.subTitle"
                        :is-card-body-max-width="true"
                        :data-oevent-category="faq.tms.tagZone"
                        :data-oevent-action="getFaqTagName(textBlock.subTitle)"
                        :data-oevent-label="getFaqTagTarget(faq.tms.tagTarget, textBlock.subTitle)"
                    >
                        <div v-html="textBlock.text" />
                    </ob1-expanding-accordion-card>
                </div>
            </div>
        </section>
        <ob1-liens-haut-bas
            :is-collapsed="false"
            collapsed-block-id="legal-mentions-4xcb-block"
            :button-label="cgu.title"
            button-id="legal-mentions-4xcb-link"
        >
            <p v-html="cgu.text" />
        </ob1-liens-haut-bas>
    </div>
</template>
<script>

export default {
    name: 'Cb4xModalContent',
    props: {
        id: {
            type: String,
            required: false,
            default: ""
        },
        oneShotPrice: {
            type: Number,
            required: true
        },
        firstMonthlyPrice: {
            type: Number,
            required: true
        },
        monthlyPrice: {
            type: Number,
            required: true
        },
        illustration: {
            type: Object,
            required: false,
            default: undefined
        },
        headerBlock: {
            type: Object,
            required: true
        },
        paymentBlock: {
            type: Object,
            required: false,
            default: undefined
        },
        paymentExampleBlock: {
            type: Object,
            required: false,
            default: undefined
        },
        paymentSimulationBlock: {
            type: Object,
            required: true
        },
        howToBenefit: {
            type: Object,
            required: false,
            default: undefined
        },
        faq: {
            type: Object,
            required: false,
            default: undefined
        },
        cgu: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatNumberToString: function (number) {
            return (number / 100).toString().replace(".", ",")
        },
        getIndex: function (index) {
            return index + 1;
        },
        getFaqTagName: function (name) {
            return stripAccents(name.replace(/[?]/g, "")).split(' ').join('_');
        },
        getFaqTagTarget: function (tagTarget, target) {
            return tagTarget + stripAccents(target.replace(/[?]/g, "")).split(' ').join('_');
        },
    }
}
</script>

<style lang="scss">
@import 'ob1_common';
.illustration > img {
    height: px-to-rem(178);
}
</style>
